import { Bijection } from "./bijection";

/**
 * Abstract synchronous storage for a single value.
 * This may perform automatic encoding/decoding operations on the underlying
 * stored data.
 */
export interface Store<T> {
  /**
   * Get the value.
   */
  get(): T;
  /**
   * Set the value.
   */
  set(value: T): void;
}

/**
 * Apply a bijective transform to the store.
 */
export function storeTransform<A, B>(
  store: Store<A>,
  transform: Bijection<A, B>,
): Store<B> {
  return {
    get() {
      return transform.read(store.get());
    },
    set(value) {
      store.set(transform.write(value));
    },
  };
}
